// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2022project/q1/2022western/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const token =
  'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vZGV2YXBpLmNxY2IuY29tL2FwaS91c2VyL2xvZ2luIiwiaWF0IjoxNjMxMTU1MTU4LCJleHAiOjE2MzExNTUyMTgsIm5iZiI6MTYzMTE1NTE1OCwianRpIjoidTFRMEJBam5GMDl2a1p1VSIsInN1YiI6ODc1MzYzLCJwcnYiOiI4NjY1YWU5Nzc1Y2YyNmY2YjhlNDk2Zjg2ZmE1MzZkNjhkZDcxODE4In0.droYDhfvZ6y2UZ-w8x_WscBeFqeY5C3WQGFcC69Lv5E';
// 获取列表
const getList = (page: number, keyword?: string, workType?: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
      workType,
    },
  });
};

const workType = () => {
  return http.get(`${urlPrefix}workType`);
};
// 获取详情
export const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

// 规则
export const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

// 通用付费投票信息
export const vote = (data: any) => {
  return http.post(
    `vote/public/pay/controller.php?enews=vote&act_id=${data.act_id}`,
    qs.stringify(data),
    {},
  );
};

// 通用用户信息
export const userInfo = (actId: number) => {
  return http.get(
    `vote/public/pay/controller.php?enews=user-info&act_id=${actId}`,
    {
      headers: {},
    },
  );
};

// 余额
export const voteNum = (actId: number) => {
  return http.get(
    `vote/public/pay/controller.php?enews=voteNum&act_id=${actId}`,
    {
      headers: {},
    },
  );
};

// 消费记录
export const consumption = (actId: number, page: number) => {
  return http.get(
    `vote/public/pay/controller.php?enews=consumption&act_id=${actId}&page=${page}`,
    {
      headers: {},
    },
  );
};

// 充值记录
export const recharge = (actId: number, page: number) => {
  return http.get(
    `vote/public/pay/controller.php?enews=recharge&act_id=${actId}&page=${page}`,
    {
      headers: {},
    },
  );
};

// 通用支付
export const pay = (data: any) => {
  return http.post(`vote/public/pay/pay.php`);
};

export { getBaseInfo, getList, workType };
